import { systemConstants } from "../../constants";
import { custom } from "./utilities";

const toggleSailorProfile = (value) => {
  return (dispatch) => {
    dispatch(custom(value, systemConstants.TOGGLE_SAILOR_PROFILE));
  };
};

export const systemActions = { toggleSailorProfile };
